const AdminCandidatesList = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/candidatesList/AdminCandidatesList.vue"
  );
const AdminCandidatesReceivability = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/receivability/AdminCandidatesReceivability.vue"
  );
const AdminCandidatesDecision = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/decision/AdminCandidatesDecision.vue"
  );
const AdminCandidatesRenewal = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/renewal/AdminCandidatesRenewal.vue"
  );

export default [
  {
    path: "candidatesList",
    name: "admin-candidates-candidatesList",
    component: AdminCandidatesList,
  },
  {
    path: "receivability",
    name: "admin-candidates-receivability",
    component: AdminCandidatesReceivability,
  },
  {
    path: "decision",
    name: "admin-candidates-decision",
    component: AdminCandidatesDecision,
  },
  {
    path: "renewal",
    name: "admin-candidates-renewal",
    component: AdminCandidatesRenewal,
  },
];
